import { Card } from "@adyen/adyen-web";
import { AddAccountApiParameterExt, addAccountExt as addAccountApiExt } from "@GeriMed/Services/AccountServiceExt";
import { becomeACustomer, BecomeACustomerParameterExt } from "@GeriMed/Services/BecomeACustomer";
import { invoicePayment, InvoicePaymentApiParameter } from "@GeriMed/Services/GmInvoiceService";
import {  BecomeACustomerModel, InvoicePaymentModel } from "@GeriMed/Type/ApiModelsExt";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import { CreditCardDto } from "@insite/client-framework/Types/ApiModels";

export interface InvoiceCCPaymentParameter {
    invoiceNumber: string;
    amount: string;
    //paymentMethod: string;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    isBulkPayment:boolean;
    invoices:string;
    // accountHolderName?: string;
    // accountNumber?: string;
    // routingNumber?: string;
    // payerId: string;
    // maskedCardNumber: string;
    //Properties: any;
    onSuccess?: () => void;
    onError?: () => void;
}
interface InvoicePaymentResult  {
    Success : boolean;
}

type HandlerType = ApiHandlerDiscreteParameter<
    InvoiceCCPaymentParameter,
    InvoicePaymentApiParameter,
    ServiceResult<boolean>
>;

export const PopulateApiParameterExt: HandlerType = props => {
    props.apiParameter = {
        invoiceParameter: {
             invoiceNumber:props.parameter.invoiceNumber,
             amount:props.parameter.amount,
             creditCard:{
                cardHolderName:props.parameter.cardHolderName,
                cardNumber:props.parameter.cardNumber,
                cardType : props.parameter.cardType,
                expirationMonth : props.parameter.expirationMonth,
                expirationYear : props.parameter.expirationYear,
                securityCode : props.parameter.securityCode
             } as unknown as CreditCardDto,
             isBulkPayment:props.parameter.isBulkPayment,
             invoices: props.parameter.invoices,
             
        } as unknown as InvoicePaymentModel,
    };
};

export const InvoiceCCPayment: HandlerType = async props => {
    //stopWatchingForOtherTabSessionChange();
    const invResult = await invoicePayment(props.apiParameter);

    if(invResult.success)
    {
        props.parameter.onSuccess?.();
    }
    else
    {
        props.parameter.onError?.();
    }
    //watchForOtherTabSessionChange();
};

export const chain = [
    PopulateApiParameterExt,
    InvoiceCCPayment,
];

const invoiceCCPayment = createHandlerChainRunner(chain, "InvoiceCCPayment");
export default invoiceCCPayment;
